var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from "tailwind-merge";
import { SCALING } from "../../types/global";
function GetScalingColorsForChamp(_a) {
    var champion = _a.champion, className = _a.className;
    return (_jsx("div", __assign({ className: twMerge(" flex items-center justify-start gap-2", className) }, { children: SCALING.map(function (scaling) { return (_jsx("div", { className: twMerge("h-2 w-6 rounded-full ", champion["".concat(scaling, "_color")] === "Green" && "bg-scale-green ", champion["".concat(scaling, "_color")] === "Yellow" && "bg-scale-yellow ", champion["".concat(scaling, "_color")] === "Red" && "bg-scale-red ") }, scaling)); }) })));
}
export default GetScalingColorsForChamp;
